import ApplicationController from "application_controller.js";
import { useAssetLoader } from "mixins";
import Flickity from "flickity";
import "flickity-as-nav-for";
import "flickity-imagesloaded";
// import "flickity-fullscreen";
// import "flickity-fade";
// import "flickity-hash";
// import "flickity-sync";
// import "flickity-bg-lazyload";

export default class extends ApplicationController {
  debug = false;

  static targets = ["gallery", "nav", "cell", "caption", "activeCaption", "ratioContainer"];
  static values = {
    nav: { type: Boolean, default: true },
    autoPlay: { type: Boolean, default: false },
    captions: { type: Boolean, default: false },
    captionClass: { type: String, default: "" },
    wrapAround: { type: Boolean, default: true },
  };

  initialize() {
    this.log_function("initialize");

    useAssetLoader(this);

    this.flickityGallery = false;
    this.FlickityNav = false;
  }

  connect() {
    this.log_function("connect");

    this.initGallery();
    if (this.shouldInitNav) this.initNav();
    if (this.captionsValue) this.initCaptions();
  }

  initGallery() {
    this.log_function("initGallery");

    const options = {
      cellSelector: ".carousel-cell",
      pageDots: false,
      adaptiveHeight: !this.autoPlayValue,
      contain: true,
      wrapAround: this.wrapAroundValue,
      imagesLoaded: true,
      setGallerySize: false,
      fullscreen: false,
      sync: false,
      bgLazyLoad: false,
      on: {
        ready: this.handleReady.bind(this),
        change: this.handleChange.bind(this),
        settle: this.handleSettle.bind(this),
      },
    };

    if (this.autoPlayValue) {
      options.autoPlay = true;
      options.lazyLoad = true;
    }

    this.flickityGallery = new Flickity(this.galleryTarget, options);
  }

  initNav() {
    this.log_function("initNav");

    this.FlickityNav = new Flickity(this.navTarget, {
      cellSelector: ".carousel-cell",
      asNavFor: this.galleryTarget,
      contain: true,
      pageDots: false,
      cellAlign: "left",
      wrapAround: false,
      prevNextButtons: false,
      imagesLoaded: true,
      setGallerySize: false,
    });
  }

  initCaptions() {
    this.log_function("initCaptions");

    const captionElement = document.createElement("div");
    if (this.captionClassValue) {
      captionElement.classList.add(...this.captionClassValue.split(" "));
    }
    captionElement.setAttribute(`data-${this.identifier}-target`, "activeCaption");
    this.element.appendChild(captionElement);

    // Store direct reference since MutationObserver target registration is async
    this._captionElement = captionElement;
    this.updateCaption();
  }

  updateCaption() {
    this.log_function("updateCaption");

    const captionEl = this._captionElement || (this.hasActiveCaptionTarget ? this.activeCaptionTarget : null);
    if (!captionEl) return;

    const selectedIndex = this.flickityGallery.selectedIndex;
    const captionSelector = `[data-${this.identifier}-target="caption"]`;
    const activeCaption = this.flickityGallery?.cells[selectedIndex]?.element?.querySelector(captionSelector);

    captionEl.innerHTML = activeCaption?.innerHTML || "\u00A0";
  }

  handleReady() {
    this.log_function("handleReady");

    this.checkPageDecorationHide(0);
    if (this.captionsValue) this.updateCaption();
  }

  handleChange(index) {
    this.log_function("handleChange", index);

    this.checkPageDecorationHide(index);
    if (this.captionsValue) this.updateCaption();
  }

  handleSettle(index) {
    this.log_function("handleSettle", index);
  }

  checkPageDecorationHide(index) {
    this.log_function("checkPageDecorationHide", index);

    const carouselCells = this.galleryTarget.getElementsByClassName("carousel-cell");
    const selectedCarouselCell = carouselCells[index];
    if (!selectedCarouselCell) return;

    const hidePageDecoration = selectedCarouselCell.classList.contains("hide-page-decoration");
    const decorations = document.getElementsByClassName("page-decoration");

    if (decorations.length > 0) {
      const firstDecoration = decorations[0];
      if (hidePageDecoration) {
        this.fadeOut(firstDecoration);
      } else {
        this.fadeIn(firstDecoration);
      }
    }
  }

  // https://gist.github.com/alirezas/c4f9f43e9fe1abba9a4824dd6fc60a55
  fadeOut(element) {
    this.log_function("fadeOut", element);

    element.style.opacity = 1;

    if (!element.classList.contains("page-decoration-hidden")) {
      (function fade() {
        if ((element.style.opacity -= .1) < 0) {
          element.classList.add("page-decoration-hidden");
        } else {
          requestAnimationFrame(fade);
        }
      })();
    }
  }

  fadeIn(element) {
    this.log_function("fadeIn", element);

    if (element.classList.contains("page-decoration-hidden")) {
      element.style.opacity = 0;
      element.classList.remove("page-decoration-hidden");

      (function fade() {
        var val = parseFloat(element.style.opacity);
        if (!((val += .1) > 1)) {
          element.style.opacity = val;
          requestAnimationFrame(fade);
        }
      })();
    }
  }

  get shouldInitNav() {
    this.log_function("shouldInitNav");

    return this.navValue && this.hasNavTarget;
  }

  disconnect() {
    this.log_function("disconnect");

    if (this.flickityGallery) {
      this.log_function("disconnect", "this.flickityGallery.destroy()");
      this.flickityGallery.destroy();
    }

    if (this.FlickityNav) {
      this.log_function("disconnect", "this.FlickityNav.destroy()");
      this.FlickityNav.destroy();
    }
  }
}
